export default "<p class=\"semiBoldMont font14px blackColor noMargin\">\n  Coming soon!\n</p>\n"